import dayjs from './datetime';

/**
 * @returns {string}
 */
const getGreeting = () => {
  const now = dayjs();

  const evening = now
    .clone()
    .set('hour', 18)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0);

  if (now.isAfter(evening)) {
    return 'Good evening';
  }

  const noon = now
    .clone()
    .set('hour', 11)
    .set('minute', 59)
    .set('second', 59)
    .set('millisecond', 59);

  if (now.isAfter(noon)) {
    return 'Good afternoon';
  }

  return 'Good morning';
};

export default getGreeting;
